<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isServiceAdmin()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <!-- main row for all icons  -->

            <div class="col-sm-12">
                <div class="col-sm-4">
                    <!-- <LogoPrint></LogoPrint> -->
                </div>
                <div class="col-sm-4"></div>
            </div>
            <br />

            <div
                class="alert alert-danger center center-block"
                align="center"
                role="alert"
                v-if="job.customer_id == null"
            >
                <h4>Customer details not added</h4>
            </div>

            <br />

            <div
                class="col-md-12"
                v-if="
                    $gate.isZonalManager() ||
                    $gate.isMISAdmin() ||
                    $gate.isDOAManager() ||
                    $gate.isReplacementManager() ||
                    $gate.isExtWarrAdmin() ||
                    $gate.isSecondaryMISAdmin() ||
                    $gate.isServiceManager() ||
                    $gate.isServiceAdmin() ||
                    $gate.isServiceTech() ||
                    $gate.isWarehouseManager() ||
                    $gate.isStoreManager() ||
                    $gate.isServiceAgent()
                "
            >
                <div class="row">
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-12">
                                <button
                                    class="btn btn-secondary"
                                    style="width: 80%"
                                    @click="change"
                                >
                                    <i class="fa fa-cog"></i> Customer Status
                                </button>
                            </div>
                            <div class="col-sm-12">
                                <br />
                            </div>
                            <div class="col-sm-12">
                                <button
                                    class="btn btn-danger"
                                    style="width: 80%"
                                    @click="add"
                                >
                                    <i class="fa fa-plus"></i> Add Internal Note
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-12">
                                <button
                                    class="btn btn-secondary"
                                    style="width: 80%"
                                    @click="partsModal"
                                >
                                    <i class="fa fa-cog"></i> Request Part
                                </button>
                            </div>
                            <div class="col-sm-12">
                                <br />
                            </div>
                            <div class="col-sm-12">
                                <button
                                    class="btn btn-secondary"
                                    style="width: 80%"
                                    @click="consumeModal"
                                >
                                    <i class="fa fa-cog"></i> Consume Part
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="row">
                            <div class="col-sm-12">
                                <button
                                    class="btn btn-danger"
                                    style="width: 80%"
                                    @click="jobSheet(job)"
                                >
                                    <i class="fa fa-eye"></i> View Job Sheet
                                </button>
                            </div>
                            <div class="col-sm-12">
                                <br />
                            </div>
                            <div
                                class="col-sm-12"
                                v-if="
                                    job.accounts_closed == 'Yes' &&
                                    job.assigned_name != null
                                "
                            >
                                <button
                                    v-if="
                                        job.erp_invoice_info == null ||
                                        $gate.isMISAdmin() ||
                                        $gate.isServiceAdmin()
                                    "
                                    class="btn btn-secondary"
                                    style="width: 80%"
                                    @click="updateInvoiceNumberPrompt"
                                >
                                    <i class="fa fa-cog"></i> Update Invoice
                                    Number
                                </button>
                            </div>
                            <!--                            <div-->
                            <!--                                class="col-sm-12"-->
                            <!--                                v-if="-->
                            <!--                                    $gate.isServiceAdmin() ||-->
                            <!--                                    $gate.isServiceManager() ||-->
                            <!--                                    $gate.isServiceAgent()-->
                            <!--                                "-->
                            <!--                            >-->
                            <!--                                <button-->
                            <!--                                    class="btn btn-danger"-->
                            <!--                                    style="width: 80%"-->
                            <!--                                    v-if="-->
                            <!--                                        job.accounts_closed == 'Yes' &&-->
                            <!--                                        job.assigned_name != null &&-->
                            <!--                                        job.payment_status == 'Completed'-->
                            <!--                                    "-->
                            <!--                                    @click="jobInvoice(job)"-->
                            <!--                                >-->
                            <!--                                    <i class="fa fa-eye"></i> Job Invoice-->
                            <!--                                </button>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                    <div
                        class="col-sm-3"
                        v-if="
                            job.status == 'Completed' &&
                            job.assigned_name != null
                        "
                    >
                        <div class="row">
                            <div
                                class="col-sm-12"
                                v-if="
                                    $gate.isServiceAdmin() ||
                                    $gate.isServiceManager() ||
                                    $gate.isServiceAgent()
                                "
                            >
                                <button
                                    class="btn btn-success"
                                    style="width: 80%"
                                    @click="close"
                                    v-if="job.accounts_closed == 'No'"
                                >
                                    <i class="fa fa-check-circle"></i> Close
                                    Account Now
                                </button>
                                <button
                                    class="btn btn-success"
                                    style="width: 80%"
                                    @click="close"
                                    v-if="job.accounts_closed == 'Yes'"
                                >
                                    <i class="fa fa-check-circle"></i>
                                    Recalculate+Close
                                </button>
                            </div>
                            <div class="col-sm-12">
                                <br />
                            </div>
                            <div class="col-sm-12">
                                <button
                                    class="btn btn-primary"
                                    style="width: 80%"
                                    @click="jobOutwardSummary(job)"
                                    v-if="job.accounts_closed == 'Yes'"
                                >
                                    <i class="fa fa-receipt"></i> Print Outward
                                    Summary
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />

            <div
                class="alert alert-danger center center-block"
                align="center"
                role="alert"
                v-if="job.customer_id == null"
            >
                <h4>Customer details not added</h4>
            </div>

            <br />

            <!-- action buttons end -->
            <!-- job info summary card -->
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-body overflow-auto border-none">
                                <div class="row">
                                    <div class="col-md-8">
                                        <b>Job Category:</b>
                                        <h5>{{ job.job_category }}</h5>
                                        <br /><b>Job Status:</b><br /><span
                                            class="badge badge-warning"
                                            ><h5>
                                                &nbsp; {{ job.status }} &nbsp;
                                            </h5></span
                                        ><br />
                                        <br /><b>Job No: </b>
                                        <h5>{{ job.job_no }}</h5>
                                        <br />
                                        <b v-if="job.erp_invoice_info != null"
                                            >ERP INVOICE NUMBER:
                                        </b>
                                        <h4 v-if="job.erp_invoice_info != null">
                                            {{ job.erp_invoice_info }}
                                        </h4>
                                        <br /><b>Customer Name:</b>
                                        <h5>{{ job.customer_name }}</h5>
                                        <br /><b>Customer Phone:</b>
                                        <h5>{{ job.customer_numbers }}</h5>
                                        <br /><b>Assigned To: </b>
                                        <h5>{{ job.assigned_name }}</h5>
                                        <br />Last Status Update On:
                                        {{ job.updated_at | timeStamp }}
                                        <br />Last Status Update By:
                                        {{ job.updated_name }} <br />Job Added
                                        On:{{ job.created_at | timeStamp }}
                                        <br />Job Added By:{{
                                            job.created_name
                                        }}
                                    </div>
                                    <div class="col-md-4 float-right">
                                        <h1>{{ job.branch }}</h1>
                                        {{ job.branch_name }}
                                        <br />
                                        GST: &nbsp; {{ job.branch_gst }}
                                        <br />{{ job.cluster }}
                                        <br />
                                        <br />
                                        <br />
                                        <b>Payment Status:</b>
                                        <h5>{{ job.payment_status }}</h5>
                                        <br />
                                        <b>Total Amount:</b>
                                        <h5>{{ job.total_amount }}</h5>
                                        <br />
                                        <b>Amount Collected:</b>
                                        <h5>{{ job.amount_collected }}</h5>
                                        <br />
                                        <b>Amount Left:</b>
                                        <h5>{{ job.amount_left }}</h5>
                                        <br />
                                        <b>Estimated Total Cost of Job:</b>
                                        <h5>{{ job.estimated_cost }}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- job info summary card end -->

            <br /><br />
            <div class="col-lg-12">
                <h5>Job Assignment History</h5>
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <div class="col-sm-12">
                            <div class="row">
                                <table class="table">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>Date &amp; Time</th>
                                            <th>Assigned To</th>
                                            <th>Updated By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="a in assignment">
                                            <td>
                                                {{ a.created_at | timeStamp }}
                                            </td>
                                            <td>
                                                {{ a.assigned_to.user_detail }}
                                            </td>
                                            <td>
                                                {{ a.assigned_by.user_detail }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- job info summary card end -->

            <br /><br />

            <div class="col-lg-12">
                <h5>Job Status Timeline</h5>

                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <div class="col-sm-12">
                            <div class="row" v-if="history != ''">
                                <table class="table">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th>Date &amp; Time</th>
                                            <th>Job Status</th>
                                            <th>Updated By</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="status in history">
                                            <td>
                                                {{
                                                    status.created_at
                                                        | timeStamp
                                                }}
                                            </td>
                                            <td>{{ status.status }}</td>
                                            <td>
                                                {{
                                                    status.updated_by
                                                        .user_detail
                                                }}
                                            </td>
                                            <td>{{ status.remarks }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />

            <div class="col-lg-12" v-if="job.gatepass_id != null">
                <div class="card card-secondary">
                    <div class="card-header">
                        <div class="card-title">GATEPASS Status Timeline</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                class="btn btn-danger"
                                @click="getGatepassHistory"
                            >
                                <i class="fa fa-refresh"></i> Reload
                            </button>
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body overflow-auto">
                        <div class="row">
                            <table class="table">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>Date &amp; Time</th>
                                        <th>Status</th>
                                        <th>Updated By</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="status in gatepass_history">
                                        <td>
                                            {{ status.created_at | timeStamp }}
                                        </td>
                                        <td>
                                            <h5
                                                v-if="
                                                    status.status == 'Converted'
                                                "
                                            >
                                                <span
                                                    class="right badge badge-success"
                                                    >{{ status.status }}</span
                                                >
                                            </h5>
                                            <h5
                                                v-if="
                                                    status.status ==
                                                    'Action Taken - Case Closed'
                                                "
                                            >
                                                <span
                                                    class="right badge badge-success"
                                                    >{{ status.status }}</span
                                                >
                                            </h5>
                                            <h5
                                                v-if="
                                                    status.status ==
                                                    'Feedback Call Done'
                                                "
                                            >
                                                <span
                                                    class="right badge badge-success"
                                                    >{{ status.status }}</span
                                                >
                                            </h5>
                                            <h5
                                                v-if="
                                                    status.status ==
                                                    'Job Closed and Delivered'
                                                "
                                            >
                                                <span
                                                    class="right badge badge-primary"
                                                    >{{ status.status }}</span
                                                >
                                            </h5>
                                            <h5
                                                v-if="
                                                    status.status ==
                                                    'Feedback Negative - Action Required'
                                                "
                                            >
                                                <span
                                                    class="right badge badge-danger"
                                                    >{{ status.status }}</span
                                                >
                                            </h5>
                                            <h5 v-if="status.status == 'Lost'">
                                                <span
                                                    class="right badge badge-danger"
                                                    >{{ status.status }}</span
                                                >
                                            </h5>
                                            <h5
                                                v-if="
                                                    status.status !=
                                                        'Converted' &&
                                                    status.status != 'Lost' &&
                                                    status.status !=
                                                        'Action Taken - Case Closed' &&
                                                    status.status !=
                                                        'Feedback Call Done' &&
                                                    status.status !=
                                                        'Job Closed and Delivered' &&
                                                    status.status !=
                                                        'Feedback Negative - Action Required'
                                                "
                                            >
                                                <span
                                                    class="right badge badge-secondary"
                                                    >{{ status.status }}</span
                                                >
                                            </h5>
                                        </td>
                                        <td>
                                            {{ status.created_by.user_detail }}
                                        </td>
                                        <td>{{ status.notes }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <br /><br />

            <!-- item storage card end -->

            <div class="col-lg-12">
                <h5>Item Storage Info</h5>
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <div class="col-md-12">
                            <form @submit.prevent="storeItem">
                                <div class="row">
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Room:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-group"
                                                v-model="sform.room"
                                                placeholder="Enter the room"
                                            />
                                            <span v-if="errors.room"
                                                >Enter a valid room</span
                                            >
                                        </div>
                                    </div>

                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Shelf:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-group"
                                                v-model="sform.shelf"
                                                placeholder="Enter the shelf"
                                            />
                                            <span v-if="errors.shelf"
                                                >Enter a valid shelf</span
                                            >
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-secondary"
                                                >Rack:</span
                                            >
                                            <input
                                                type="text"
                                                class="form-group"
                                                v-model="sform.rack"
                                                placeholder="Enter the rack"
                                            />
                                            <span v-if="errors.rack"
                                                >Enter a valid rack</span
                                            >
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <input
                                                type="hidden"
                                                v-model="sform.job_id"
                                                value="job.job_id"
                                            />
                                            <button
                                                type="submit"
                                                class="btn btn-danger"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <!-- shelf details card end -->

            <!-- main row for all icons  -->

            <div
                class="col-lg-12"
                v-if="
                    $gate.isZonalManager() ||
                    $gate.isMISAdmin() ||
                    $gate.isDOAManager() ||
                    $gate.isReplacementManager() ||
                    $gate.isExtWarrAdmin() ||
                    $gate.isSecondaryMISAdmin() ||
                    $gate.isServiceManager() ||
                    $gate.isServiceAdmin() ||
                    $gate.isServiceTech() ||
                    $gate.isServiceAgent()
                "
            >
                <h5>Job Costs and Associated Fees</h5>
                <div class="card card-danger card-outline">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card-body overflow-auto">
                                <table
                                    class="table table-striped table-bordered table-hover"
                                >
                                    <thead>
                                        <tr>
                                            <th>Charge For</th>
                                            <th>Sl. No.</th>
                                            <th>Charge</th>
                                            <th>Approved</th>
                                            <th>Delete</th>
                                            <th>Approve</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="r in amounts" :key="r.id">
                                            <td>{{ r.item_name }}</td>
                                            <td>{{ r.item_sl }}</td>
                                            <td>{{ r.item_charge }}</td>
                                            <td>{{ r.approved }}</td>
                                            <td>
                                                <button
                                                    class="btn btn-danger fa fa-trash"
                                                    @click="deleteAmount(r.id)"
                                                ></button>
                                            </td>
                                            <td>
                                                <button
                                                    class="btn btn-success fa fa-check"
                                                    @click="approve(r.id)"
                                                    v-if="r.approved == 'No'"
                                                ></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer">
                                <div
                                    class="col-sm-12"
                                    v-if="job.accounts_closed == 'No'"
                                >
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    v-model="item_name"
                                                    class="form-control"
                                                    placeholder="Charge for"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <select
                                                    v-model="charge_type"
                                                    class="form-control"
                                                    placeholder="Charge Type"
                                                >
                                                    <option value="Labour">
                                                        Labour
                                                    </option>
                                                    <option
                                                        value="Outsourced Service Cost"
                                                    >
                                                        Outsourced Service Cost
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <input
                                                    type="number"
                                                    v-model="item_charge"
                                                    class="form-control"
                                                    placeholder="Charge"
                                                />
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="charge"
                                                >
                                                    Add
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <div
                class="col-md-12"
                v-if="
                    $gate.isZonalManager() ||
                    $gate.isMISAdmin() ||
                    $gate.isDOAManager() ||
                    $gate.isReplacementManager() ||
                    $gate.isExtWarrAdmin() ||
                    $gate.isSecondaryMISAdmin() ||
                    $gate.isServiceManager() ||
                    $gate.isServiceAdmin() ||
                    $gate.isServiceTech() ||
                    $gate.isServiceAgent()
                "
            >
                <h5>Amounts Collected</h5>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto">
                                <table
                                    class="table table-striped table-bordered table-hover"
                                >
                                    <thead>
                                        <tr>
                                            <th>Amount</th>
                                            <th>Entered By</th>
                                            <th>Mode</th>
                                            <th>Remarks</th>
                                            <th>Transaction ID</th>
                                            <th>Card No.</th>
                                            <th>Source Bank</th>
                                            <th>Destination Bank</th>
                                            <th>ERP Pushed</th>
                                            <th>ERP Receipt No.</th>
                                            <th>Manage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="r in payments" :key="r.id">
                                            <td>{{ r.amount }}</td>
                                            <td>{{ r.entered_name }}</td>
                                            <td>{{ r.mode }}</td>
                                            <td>{{ r.remarks }}</td>
                                            <td>{{ r.transaction_id }}</td>
                                            <td>{{ r.card_no }}</td>
                                            <td>{{ r.source_bank }}</td>
                                            <td>
                                                {{ r.destination_bank_name }}
                                            </td>
                                            <td v-if="r.erp_pushed == 0">NO</td>
                                            <td v-else>YES</td>
                                            <td>{{ r.erp_receipt_no }}</td>
                                            <td>
                                                <button
                                                    class="btn btn-primary"
                                                    @click="billPayment(r.id)"
                                                >
                                                    <i class="fa fa-print"></i>
                                                </button>
                                                <button
                                                    class="btn btn-danger"
                                                    @click="deletePayment(r.id)"
                                                    v-if="
                                                        job.status !=
                                                        'Completed'
                                                    "
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <br />
                                    <br />
                                </table>
                            </div>
                        </div>

                        <br />
                        <br />
                        <h5>Enter Collected Amounts:</h5>
                        <div class="col-sm-12" v-if="job.status != 'Completed'">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <input
                                            type="number"
                                            min="1"
                                            class="form-control"
                                            v-model="amount"
                                            placeholder="Enter received amount"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group">
                                        <v-select
                                            v-model="mode"
                                            class="form-control"
                                            type="text"
                                            label="mode"
                                            :options="modes"
                                            :reduce="(modes) => modes.mode"
                                            placeholder="Select Mode"
                                            :value="(modes) => modes.mode"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="premark"
                                            placeholder="Enter the remark"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="payment_item_code"
                                            placeholder="Enter the item code"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="transaction_id"
                                            placeholder="Enter the transaction ID"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="card_no"
                                            placeholder="Enter the card no."
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="source_bank"
                                            placeholder="Enter the source bank"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <v-select
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the destination bank"
                                            v-model="destination_bank"
                                            :options="banks"
                                            :reduce="(banks) => banks.bank_code"
                                            label="bank_name"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="erp_receipt"
                                            placeholder="Enter the erp receipt/voucher no."
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-1">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            @click="addPaymentPrompt"
                                        >
                                            <i class="fa fa-plus"></i> Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <div
                class="col-sm-12 overflow-auto"
                v-if="
                    $gate.isZonalManager() ||
                    $gate.isDOAManager() ||
                    $gate.isReplacementManager() ||
                    $gate.isExtWarrAdmin() ||
                    $gate.isMISAdmin() ||
                    $gate.isSecondaryMISAdmin() ||
                    $gate.isServiceManager() ||
                    $gate.isServiceAdmin() ||
                    $gate.isServiceTech() ||
                    $gate.isServiceAgent()
                "
            >
                <h5>Part Requests</h5>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto">
                                <table
                                    class="table table-striped table-bordered table-hover"
                                >
                                    <thead>
                                        <tr>
                                            <th>Part</th>
                                            <th>Urgency</th>
                                            <th>Status</th>
                                            <th>Manage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="r in requests" :key="r.id">
                                            <td>{{ r.part }}</td>
                                            <td>{{ r.urgency }}</td>
                                            <td>{{ r.status }}</td>
                                            <td>
                                                <button
                                                    class="btn btn-primary"
                                                    @click="requestInfo(r.id)"
                                                >
                                                    <i class="fa fa-info"></i>
                                                </button>
                                                <button
                                                    class="btn btn-success"
                                                    @click="receivedPart(r.id)"
                                                    v-if="!r.received_date"
                                                >
                                                    <i class="fa fa-check"></i>
                                                    Received
                                                </button>
                                                <!--<button class="btn btn-danger fa fa-trash" @click="deleteRequest(r.id)"></button>-->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br /><br />

            <div class="col-lg-12">
                <h5>Item Images</h5>
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div
                                            class="col-sm-2"
                                            v-for="img in images"
                                        >
                                            <img
                                                :src="img.url"
                                                width="100"
                                                height="100"
                                                @click="viewImage(img.url)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <!-- Job Card Beginning -->

            <div class="col-lg-12">
                <div class="row">
                    <div class="col-md-6">
                        <h5>Job/Item Details</h5>
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto">
                                <div class="col-sm-12">
                                    <div
                                        class="row align-content-right content-right align-right"
                                        v-if="job.status != 'Completed'"
                                    >
                                        <button
                                            class="btn btn-secondary align-right"
                                            @click="editJobModal"
                                            v-if="
                                                $gate.isZonalManager() ||
                                                $gate.isMISAdmin() ||
                                                $gate.isSecondaryMISAdmin() ||
                                                $gate.isServiceManager() ||
                                                $gate.isServiceAdmin() ||
                                                $gate.isServiceTech() ||
                                                $gate.isServiceAgent()
                                            "
                                        >
                                            <i class="fa fa-cog"></i> Edit Job
                                            Details
                                        </button>
                                    </div>
                                </div>
                                <br />Item Name:&nbsp;{{ job.item_name }}
                                <br />Model:&nbsp;{{ job.model }}
                                <br />Brand:&nbsp;{{ job.brand }}
                                <br />IMEI:&nbsp;{{ job.sl_no }}
                                <br />Type:&nbsp;{{ job.type }} <br />Item
                                Category:&nbsp;{{ job.category }}
                                <br />Complaint:&nbsp;{{ job.complaint }}
                                <br />Accessories Received:&nbsp;{{
                                    job.accessories_received
                                }}
                                <br />Bought from Oxygen:&nbsp;{{
                                    job.oxygen_bought
                                }}
                                <br />Purchased From:&nbsp;{{
                                    job.purchased_from
                                }}
                                <br />Purchased Year:&nbsp;{{
                                    job.purchased_year | formattedDateWithOne
                                }}
                                <br />Bill Number:&nbsp;{{ job.bill_number }}
                                <br />ERP Item Code:&nbsp;{{ job.item_code }}
                                <br />Current Condition:
                                {{ job.current_condition }}
                                <!-- {{job.customer_id}} -->
                                <br />Expected Delivery Date:
                                {{
                                    job.expected_delivery_date
                                        | formattedDateWithOne
                                }}
                                <br />Description: {{ job.description }}
                                <!-- content here -->
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h5>Customer Details</h5>
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto">
                                <div class="col-sm-12">
                                    <div class="row"></div>
                                </div>

                                <br /><b>Customer Name:</b>
                                <h5>{{ job.customer_name }}</h5>
                                <br /><b>Customer Phone:</b>
                                <h5>{{ job.customer_numbers }}</h5>
                                <br /><b>Communication Address:</b>
                                <h5>{{ job.comm }}</h5>
                                <br /><b>Billing Address:</b>
                                <h5>{{ job.bill }}</h5>
                                <!-- {{job.customer_id}} -->

                                <!-- content here -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Job Card End -->

            <br />
            <br />

            <div
                class="col-lg-12"
                v-if="
                    $gate.isZonalManager() ||
                    $gate.isMISAdmin() ||
                    $gate.isDOAManager() ||
                    $gate.isReplacementManager() ||
                    $gate.isExtWarrAdmin() ||
                    $gate.isSecondaryMISAdmin() ||
                    $gate.isServiceManager() ||
                    $gate.isServiceAdmin() ||
                    $gate.isServiceTech() ||
                    $gate.isServiceAgent()
                "
            >
                <h5>Payment Data</h5>
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-2">
                                    <b>Payment Status:</b>
                                    <h5>{{ job.payment_status }}</h5>
                                    <br />
                                    <br />
                                </div>
                                <div class="col-sm-2">
                                    <b>Total Amount:</b>
                                    <h5>{{ job.total_amount }}</h5>
                                    <br />
                                    <br />
                                </div>
                                <div class="col-sm-2">
                                    <b>Amount Collected:</b>
                                    <h5>{{ job.amount_collected }}</h5>
                                    <br />
                                    <br />
                                </div>
                                <div class="col-sm-2">
                                    <b>Amount Left:</b>
                                    <h5>{{ job.amount_left }}</h5>
                                    <br />
                                    <br />
                                </div>
                                <div class="col-sm-2">
                                    <b>Estimated Total:</b>
                                    <h5>{{ job.estimated_cost }}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Payments card end -->

            <br />
            <br />

            <div
                class="col-lg-12"
                v-if="
                    $gate.isZonalManager() ||
                    $gate.isMISAdmin() ||
                    $gate.isDOAManager() ||
                    $gate.isReplacementManager() ||
                    $gate.isExtWarrAdmin() ||
                    $gate.isSecondaryMISAdmin() ||
                    $gate.isServiceManager() ||
                    $gate.isServiceAdmin() ||
                    $gate.isServiceTech() ||
                    $gate.isServiceAgent()
                "
            >
                <div class="row">
                    <div class="col-lg-4">
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-12"><br /></div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label
                                                    >Update Estimated
                                                    Cost</label
                                                >
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    placeholder="Enter the estimated cost"
                                                    v-model="job.estimated_cost"
                                                    min="1"
                                                />
                                            </div>
                                            <div class="col-sm-12"><br /></div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-primary"
                                                    @click="changeEstimate"
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-12"><br /></div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label>Case ID</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the case ID"
                                                    v-model="job.case_id"
                                                />
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the date of registration"
                                                />
                                            </div>
                                            <div class="col-sm-12"><br /></div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-primary"
                                                    @click="changeCase"
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="col-lg-4"
                        v-if="
                            $gate.isZonalManager() ||
                            $gate.isMISAdmin() ||
                            $gate.isDOAManager() ||
                            $gate.isReplacementManager() ||
                            $gate.isExtWarrAdmin() ||
                            $gate.isSecondaryMISAdmin() ||
                            $gate.isServiceManager() ||
                            $gate.isServiceAdmin() ||
                            $gate.isServiceTech() ||
                            $gate.isServiceAgent()
                        "
                    >
                        <div class="card card-danger card-outline">
                            <div class="card-body overflow-auto">
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label
                                                    >Authorized Dealer
                                                    Name</label
                                                >
                                                <v-select
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the authorized dealer name"
                                                    v-model="
                                                        job.authorized_dealer_name
                                                    "
                                                    :options="centres"
                                                    :reduce="
                                                        (centres) =>
                                                            centres.name
                                                    "
                                                    label="name"
                                                ></v-select>
                                            </div>
                                            <div class="form-group">
                                                <label>Registered Job ID</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the outsourced job ID"
                                                    v-model="
                                                        job.authorized_dealer_case
                                                    "
                                                />
                                            </div>
                                            <div class="form-group">
                                                <label>Registration Date</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    placeholder="Enter the case date"
                                                    v-model="
                                                        job.case_registration_date
                                                    "
                                                />
                                            </div>
                                            <div class="form-group">
                                                <button
                                                    class="btn btn-primary"
                                                    @click="changeAuthDealer"
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- remarks start -->
            <div
                class="col-lg-12"
                v-if="
                    $gate.isZonalManager() ||
                    $gate.isMISAdmin() ||
                    $gate.isDOAManager() ||
                    $gate.isReplacementManager() ||
                    $gate.isExtWarrAdmin() ||
                    $gate.isSecondaryMISAdmin() ||
                    $gate.isServiceManager() ||
                    $gate.isServiceAdmin() ||
                    $gate.isServiceTech() ||
                    $gate.isServiceAgent()
                "
            >
                <h5>Remarks</h5>
                <div class="row">
                    <div class="col-sm-3" v-for="r in remarks" :key="r.id">
                        <div class="card card-danger card-outline">
                            <div class="card-body">
                                <p>{{ r.remark }}</p>
                                <p>
                                    By, {{ r.created_name }} at
                                    {{ r.created_at | timeStamp }}
                                </p>
                                <button
                                    class="btn btn-danger fa fa-trash"
                                    @click="deleteRemark(r.id)"
                                ></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="row">
                    <br />
                    <br />
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->
        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="editJobModal"
            v-if="job.status != 'Closed'"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title"></div>
                    </div>
                    <div class="modal-body">
                        <div class="col-sm-12">
                            <form @submit.prevent="addJob">
                                <div
                                    :class="[
                                        'form-group',
                                        errors.item_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Item Name:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the item name"
                                        v-model="form.item_name"
                                    />
                                    <span
                                        v-if="errors.item_name"
                                        :class="['badge bg-danger']"
                                        >Please enter the item name</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.item_code ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Item Code:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the item code"
                                        v-model="form.item_code"
                                    />
                                    <span
                                        v-if="errors.item_code"
                                        :class="['badge bg-danger']"
                                        >Please enter the item code</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Branch:</label>
                                    <v-select
                                        v-model="form.branch"
                                        class="form-control"
                                        type="text"
                                        label="branch"
                                        :options="branches"
                                        :reduce="
                                            (branches) => branches.branch_code
                                        "
                                        name="branch"
                                        placeholder="Select Branch"
                                        :value="
                                            (branches) => branches.branch_code
                                        "
                                    ></v-select>
                                    <span
                                        v-if="errors.branch"
                                        :class="['badge bg-danger']"
                                        >Please choose a branch</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.brand ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Brand:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the brand"
                                        v-model="form.brand"
                                    />
                                    <span
                                        v-if="errors.brand"
                                        :class="['badge bg-danger']"
                                        >Please enter the brand</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.model ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Model:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the model"
                                        v-model="form.model"
                                    />
                                    <span
                                        v-if="errors.model"
                                        :class="['badge bg-danger']"
                                        >Please enter the model</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.category ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Category: </label>
                                    <v-select
                                        v-model="form.category"
                                        type="text"
                                        label="name"
                                        :options="categories"
                                        :reduce="
                                            (categories) => categories.name
                                        "
                                        placeholder="Select Item Category"
                                        :value="(categories) => categories.name"
                                    ></v-select>
                                    <span
                                        v-if="errors.category"
                                        :class="['badge bg-danger']"
                                        >Please choose category</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.type ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Type:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the item type"
                                        v-model="form.type"
                                    />
                                    <span
                                        v-if="errors.type"
                                        :class="['badge bg-danger']"
                                        >Please enter the type</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.sl_no ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Serial No.:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the serial no."
                                        v-model="form.sl_no"
                                    />
                                    <span
                                        v-if="errors.sl_no"
                                        :class="['badge bg-danger']"
                                        >Please enter the serial no.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.complaint ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Complaint:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the complaint"
                                        v-model="form.complaint"
                                    />
                                    <span
                                        v-if="errors.complaint"
                                        :class="['badge bg-danger']"
                                        >Please enter the complaint.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.current_condition
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Current Condition:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the current condition"
                                        v-model="form.current_condition"
                                    />
                                    <span
                                        v-if="errors.current_condition"
                                        :class="['badge bg-danger']"
                                        >Please enter the current
                                        condition</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.accessories_received
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Accessories Received:</label>
                                    <div
                                        class="form-check form-check-inline"
                                        v-for="a in accessories"
                                        :key="a.id"
                                    >
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :id="a.accessory"
                                            :value="a.accessory"
                                            v-model="accessories_received"
                                            name="accessory"
                                        />
                                        <label
                                            class="form-check-label"
                                            :for="a.accessory"
                                            >{{ a.accessory }}</label
                                        >
                                    </div>
                                    <span
                                        v-if="errors.accessories_received"
                                        :class="['badge bg-danger']"
                                        >Please enter the accessories
                                        received</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.description ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Description:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the description"
                                        v-model="form.description"
                                    />
                                    <span
                                        v-if="errors.description"
                                        :class="['badge bg-danger']"
                                        >Please enter the description</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.purchased_year
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Purchased year:</label>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter the year of purchase"
                                        v-model="form.purchased_year"
                                    />
                                    <span
                                        v-if="errors.purchased_year"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid year.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.oxygen_bought ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Oxygen Bought:</label>
                                    <select
                                        class="form-control"
                                        placeholder="Oxygen Bought"
                                        v-model="form.oxygen_bought"
                                    >
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                    <span
                                        v-if="errors.oxygen_bought"
                                        :class="['badge bg-danger']"
                                        >Please choose.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.job_category ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Job Category:</label>
                                    <v-select
                                        placeholder="Job Category"
                                        v-model="form.job_category"
                                        :options="job_categories"
                                        :reduce="
                                            (job_categories) =>
                                                job_categories.name
                                        "
                                        label="name"
                                    ></v-select>
                                    <span
                                        v-if="errors.oxygen_bought"
                                        :class="['badge bg-danger']"
                                        >Please choose.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.purchased_from
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Purchased From:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter where the item was purchased from"
                                        v-model="form.purchased_from"
                                    />
                                    <span
                                        v-if="errors.purchased_from"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid character.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.bill_no ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Bill No.:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the bill no."
                                        v-model="form.bill_number"
                                    />
                                    <span
                                        v-if="errors.bill_no"
                                        :class="['badge bg-danger']"
                                        >Please enter the bill no.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.expected_delivery_date
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Expected Delivery:</label>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter expected delivery date"
                                        v-model="form.expected_delivery_date"
                                    />
                                    <span
                                        v-if="errors.expected_delivery_date"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid date.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.customer_name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Customer Name:</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter customer name"
                                        v-model="form.customer_name"
                                    />
                                    <span
                                        v-if="errors.customer_name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.customer_phone
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Customer Phone:</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        placeholder="Enter customer phone"
                                        v-model="form.customer_phone"
                                    />
                                    <span
                                        v-if="errors.customer_phone"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid number.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.expected_delivery_date
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                    >
                                        Update
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="statusModal"
            v-if="job.status != 'Completed'"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Change Status</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Choose Status:</label>
                            <v-select
                                v-model="status"
                                type="text"
                                label="status"
                                :options="statuses"
                                :reduce="(statuses) => statuses.status"
                                placeholder="Select Status"
                                :value="(statuses) => statuses.status"
                            ></v-select>
                        </div>
                        <div
                            :class="[
                                'form-group',
                                errors.status_remark ? 'has-error' : '',
                            ]"
                        >
                            <label>Remark</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Enter a remark"
                                v-model="status_remark"
                            />
                            <span
                                v-if="errors.remarks"
                                :class="['badge bg-danger']"
                                >Please enter a valid remark.</span
                            >
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary" @click="update">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="paymentModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <h3>Are you sure you want to add payment?</h3>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success" @click="addPayment">
                            Yes
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            No
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="partsModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Request Part</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Part</label>
                            <input
                                type="text"
                                v-model="request_part"
                                class="form-control"
                                placeholder="Enter the part to request"
                            />
                        </div>
                        <div class="form-group">
                            <v-select
                                v-model="request_branch"
                                class="form-control"
                                type="text"
                                label="branch"
                                :options="branches"
                                :reduce="(branches) => branches.branch_code"
                                name="branch"
                                placeholder="Select Branch"
                                :value="(branches) => branches.branch_code"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label>Urgency</label>
                            <select
                                class="form-control"
                                v-model="request_urgency"
                            >
                                <option value="High">High</option>
                                <option value="Medium">Medium</option>
                                <option value="Low">Low</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Remarks</label>
                            <input
                                type="text"
                                v-model="request_remarks"
                                class="form-control"
                                placeholder="Enter the remarks"
                            />
                        </div>
                        <div class="form-group">
                            <button class="btn btn-danger" @click="requestPart">
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="consumeModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">User Part</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Assign Item</label>
                            <v-select
                                v-model="inv_item"
                                :options="inventory"
                                label="display_name"
                                :reduce="(inventory) => inventory.id"
                                placeholder="Choose item"
                                :value="(inventory) => inventory.id"
                            ></v-select>
                            <input type="number" class
                        </div>
                        <div class="form-group">
                            <label>Consumed Price</label>
                            <input
                                v-model="inv_item_price"
                                placeholder="Enter Price"
                                class="form-control"
                            />
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary" @click="assignPart">
                                Assign
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateInvoiceModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Invoice Number</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>ERP Bill Number</label>
                            <input
                                v-model="erp_invoice_no"
                                class="form-control"
                                type="text"
                            />
                        </div>
                        <div class="form-group">
                            <button
                                class="btn btn-primary"
                                @click="updateInvoiceNumber"
                            >
                                Update Job's Bill Info
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="remarkModal"
            v-if="job.status != 'Completed'"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Remark</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div
                            :class="[
                                'form-group',
                                errors.remark ? 'has-error' : '',
                            ]"
                        >
                            <label>Remark</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Enter a remark"
                                v-model="remark"
                            />
                            <span
                                v-if="errors.remark"
                                :class="['badge bg-danger']"
                                >Please enter a valid remark.</span
                            >
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary" @click="addRemark">
                                Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="viewRequest">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Request Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Part: <b></b>{{ item_request.part }}</p>
                        <p>Urgency: <b></b>{{ item_request.urgency }}</p>
                        <p>Branch: <b></b>{{ item_request.branch }}</p>
                        <p>
                            Fulfilled By: <b></b
                            >{{ item_request.fulfilled_name }}
                        </p>
                        <p>Requested At: <b></b>{{ item_request.created }}</p>
                        <p>Fulfilled At: <b></b>{{ item_request.fulfilled }}</p>
                        <p>Price: <b></b>{{ item_request.item_price }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isServiceAdmin()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getJobDets();
        this.getStatuses();
        this.getAllCentres();
        this.getAccessories();
        this.getCategories();
        this.getBanks();
        this.getModes();
        this.getBranches();
        this.getJobCategories();
    },

    data() {
        return {
            job: [],
            statuses: [],
            ownership: [],
            assignment: [],
            status: "",
            erp_invoice_no: "",
            status_remark: "",
            remarks: [],
            remark: "",
            errors: [],
            amounts: [],
            item_name: "",
            item_charge: "",
            charge_type: "",
            sform: new Form({
                job_id: "",
                room: "",
                shelf: "",
                rack: "",
                id: "",
            }),
            form: new Form({
                item_name: "",
                item_code: "",
                brand: "",
                model: "",
                purchased_year: "",
                category: "",
                type: "",
                expected_delivery_date: "",
                under_warranty: "",
                oxygen_bought: "",
                bill_number: "",
                sl_no: "",
                complaint: "",
                current_condition: "",
                accessories_received: "",
                purchased_from: "",
                id: "",
                description: "",
                job_category: "",
                customer_name: "",
                customer_phone: "",
                branch: "",
            }),
            accessories: [],
            accessories_received: [],
            categories: [],
            history: [],
            request_part: "",
            request_urgency: "",
            request_remarks: "",
            request_branch: "",
            requests: [],
            item_request: [],
            centres: [],
            inventory: [],
            inv_item: "",
            inv_item_price: "",
            images: [],
            url: "",
            card_no: "",
            source_bank: "",
            destination_bank: "",
            banks: [],
            modes: [],
            payments: [],
            transaction_id: "",
            premark: "",
            amount: "",
            mode: "",
            payment_item_code: "",
            erp_receipt: "",
            branches: [],
            job_categories: [],
            gatepass: [],
            gatepass_history: [],
            gatepass_ownership: [],
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getAllCentres() {
            axios.post("/api/getAllCentres").then((response) => {
                this.centres = response.data;
            });
        },

        getBanks() {
            axios.post("/api/getAllBanks").then((response) => {
                this.banks = response.data;
            });
        },

        getJobCategories() {
            axios.post("/api/getAllJobCategories").then((response) => {
                this.job_categories = response.data;
            });
        },

        getHistory() {
            axios
                .post("/api/getHistory", { job: this.$route.params.id })
                .then((response) => {
                    this.history = response.data;
                });
        },

        getModes() {
            axios.post("/api/getAllModes").then((response) => {
                this.modes = response.data;
            });
        },

        getCategories() {
            axios.post("/api/getAllCategories").then((response) => {
                this.categories = response.data;
            });
        },

        // getHistory(){
        // 	axios.post("/api/getHistory", {job: this.$route.params.id})
        // 	.then(response => {
        // 		this.history = response.data;
        // 	})
        // },

        jobInvoice(job) {
            this.$router.push(
                "/job-invoice/" + 0 + "/" + job.id + "/" + this.$userId
            );
        },

        jobSheet(job) {
            this.$router.push("/job-sheet-brief/" + job.id);
        },

        jobOutwardSummary(job) {
            this.$router.push("/job-outward-summary/" + job.id);
        },

        getImages() {
            axios
                .post("/api/getImages", { gatepass_id: this.job.gatepass_id })
                .then((response) => {
                    this.images = response.data;
                });
        },

        consumeModal() {
            axios.post("/api/getBranchInventory").then((response) => {
                this.inventory = response.data;
                $("#consumeModal").modal("show");
            });
        },

        assignPart() {
            axios
                .post("/api/fulfillRequestTech", {
                    id: this.inv_item,
                    job: this.job.id,
                    price: this.inv_item_price,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Consumed",
                        });
                        this.getJobDets();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        getAccessories() {
            axios.post("/api/getAllAccessories").then((response) => {
                this.accessories = response.data;
            });
        },

        printInvoice() {
            this.$router.push("/print/invoice/" + job.id);
        },

        changeAuthDealer() {
            axios
                .post("/api/changeAuthDealer", {
                    job: this.job.id,
                    auth_dealer: this.job.authorized_dealer_name,
                    auth_case_id: this.job.authorized_dealer_case,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Updated",
                        });
                        this.getJobDets();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Failed!",
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },

        editJobModal() {
            this.curr_job = this.job.id;
            this.status = this.job.status;
            if (this.form.accessories_received != null)
                this.accessories_received =
                    this.form.accessories_received.split(",");
            $("#editJobModal").modal("show");
        },

        getPayments() {
            axios
                .post("/api/getPayments", { job: this.job.id })
                .then((response) => {
                    this.payments = response.data;
                });
        },

        addPaymentPrompt() {
            $("#paymentModal").modal("show");
        },

        updateInvoiceNumberPrompt() {
            $("#updateInvoiceModal").modal("show");
        },

        addPayment() {
            if (this.mode != "Cash")
                var name = this.banks.find(
                    (c) => c.bank_code == this.destination_bank
                ).bank_name;
            axios
                .post("/api/addPayment", {
                    job: this.job.id,
                    amount: this.amount,
                    mode: this.mode,
                    remarks: this.premark,
                    transaction_id: this.transaction_id,
                    card_no: this.card_no,
                    source_bank: this.source_bank,
                    destination_bank_code: this.destination_bank,
                    destination_bank_name: name,
                    item_code: this.payment_item_code,
                    erp_receipt_no: this.erp_receipt,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Payment Added",
                        });
                        $("#paymentModal").modal("hide");
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        billPayment(id) {
            this.$router.push(
                "/advance-invoice/" +
                    id +
                    "/" +
                    this.job.id +
                    "/" +
                    this.$userId
            );
        },

        deletePayment(id) {
            axios
                .post("/api/deletePayment", { id: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Payment Deleted",
                        });
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        changeEstimate() {
            axios
                .post("/api/changeEstimate", {
                    job: this.job.id,
                    estimate: this.job.estimated_cost,
                })
                .then((response) => {
                    if (response.data == 200)
                        if (response.data == 200) {
                            toast.fire({
                                icon: "success",
                                title: "Updated",
                            });
                            this.getJobDets();
                        } else
                            toast.fire({
                                icon: "error",
                                title: "Failed!",
                            });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },

        changeCase() {
            axios
                .post("/api/changeCase", {
                    job: this.job.id,
                    case_id: this.job.case_id,
                })
                .then((response) => {
                    if (response.data == 200)
                        if (response.data == 200) {
                            toast.fire({
                                icon: "success",
                                title: "Updated",
                            });
                            this.getJobDets();
                        } else
                            toast.fire({
                                icon: "error",
                                title: "Failed!",
                            });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },

        addJob() {
            this.form.accessories_received =
                this.accessories_received.toString();
            this.form
                .post("/api/updateJob")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Job Details Updated",
                        });
                        this.getJobDets();
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        getJobDets() {
            axios
                .post("/api/getFullJobDetails", { id: this.$route.params.id })
                .then((response) => {
                    this.job = response.data;
                    this.form.fill(response.data);
                    if (this.job.gatepass_id != null) {
                        this.getGatepass();
                    }
                    this.getRemarks();
                    this.getAmounts();
                    this.getRequests();
                    this.getJobAssignmentHistory();
                    this.getShelf();
                    this.getImages();
                    this.getHistory();
                    this.getPayments();
                });
        },

        getJobAssignmentHistory() {
            axios
                .post("/api/getJobAssignmentHistory", { job_id: this.job.id })
                .then((response) => {
                    this.assignment = response.data;
                });
        },

        getGatepass() {
            axios
                .post("/api/getGatepass", { id: this.job.gatepass_id })
                .then((response) => {
                    this.gatepass = response.data;
                    this.getGatepassOwnershipHistory();
                    this.getGatepassHistory();
                    // this.history = this.gatepass.gatepass_status_histories;
                    // this.ownership = this.gatepass.gatepass_ownership_histories;
                });
        },

        getGatepassHistory() {
            axios
                .post("/api/getGatepassHistory", { id: this.gatepass.id })
                .then((response) => {
                    this.gatepass_history = response.data;
                });
        },
        getGatepassOwnershipHistory() {
            axios
                .post("/api/getGatepassOwnershipHistory", {
                    id: this.gatepass.id,
                })
                .then((response) => {
                    this.ownership = response.data;
                });
        },

        close() {
            axios
                .post("/api/closeJobAccounts", { id: this.job.id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Accounts Closed",
                        });
                        this.getJobDets();
                    } else if (response.data == 500) {
                        toast.fire({
                            icon: "error",
                            title: "Approve or Delete All Amounts",
                        });
                    }
                });
        },

        getShelf() {
            axios
                .post("/api/getShelf", { job: this.job.id })
                .then((response) => {
                    this.sform.job_id = this.job.id;
                    if (response.data != "") this.sform.fill(response.data);
                });
        },

        storeItem() {
            this.sform
                .post("/api/storeJobItem")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Storage Updated",
                        });
                        this.getShelf();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        change() {
            this.curr_job = this.job.id;
            this.status = this.job.status;
            $("#statusModal").modal("show");
        },

        getStatuses() {
            axios.post("/api/getJobStatusesAll").then((response) => {
                this.statuses = response.data;
            });
        },

        partsModal() {
            $("#partsModal").modal("show");
        },

        viewImage(url) {
            this.url = url;
            $("#imgModal").modal("show");
        },

        requestPart() {
            axios
                .post("/api/createPartRequest", {
                    job_id: this.job.id,
                    part: this.request_part,
                    urgency: this.request_urgency,
                    remarks: this.request_remarks,
                    branch: this.request_branch,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Request Made",
                        });
                        this.getJobDets();
                        this.getRequests();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Failed!",
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed!",
                    });
                });
        },

        update() {
            axios
                .post("/api/updateJobStatus", {
                    id: this.job.id,
                    status: this.status,
                    remarks: this.status_remark,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Status Updated",
                        });
                        this.getJobDets();
                        $("#statusModal").modal("hide");
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        getRemarks() {
            axios
                .post("/api/getRemarks", { job: this.job.id })
                .then((response) => {
                    this.remarks = response.data;
                });
        },

        add() {
            this.remark = "";
            $("#remarkModal").modal("show");
        },

        addRemark() {
            axios
                .post("/api/addRemark", {
                    job: this.job.id,
                    remark: this.remark,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Remark Added",
                        });
                        this.getRemarks();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        deleteRemark(id) {
            axios
                .post("/api/deleteRemark", { id: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Remark Deleted",
                        });
                        this.getRemarks();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        getAmounts() {
            axios
                .post("/api/getAmounts", { job: this.job.id })
                .then((response) => {
                    this.amounts = response.data;
                });
        },

        charge() {
            axios
                .post("/api/addAmount", {
                    job: this.job.id,
                    item_name: this.item_name,
                    item_charge: this.item_charge,
                    type: this.charge_type,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Amoount Added",
                        });
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        deleteAmount(id) {
            axios
                .post("/api/deleteAmount", { id: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Amount Deleted",
                        });
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        getRequests() {
            axios
                .post("/api/getJobRequests", { job: this.job.id })
                .then((response) => {
                    this.requests = response.data;
                });
        },

        updateInvoiceNumber() {
            axios
                .post("/api/updateJobERPInvoiceNumber", {
                    job: this.job.id,
                    invoice_no: this.erp_invoice_no,
                })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Invoice Number Updated",
                        });
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed. Try again",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        approve(id) {
            axios
                .post("/api/approveAmount", { id: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Amount Approved",
                        });
                        this.getJobDets();
                    } else {
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
        requestInfo(id) {
            axios
                .post("/api/getRequestFulfilled", { id: id })
                .then((response) => {
                    this.item_request = response.data;
                    $("#viewRequest").modal("show");
                });
        },

        receivedPart(id) {
            axios
                .post("/api/receivedRequest", { request: id })
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Acknowledged",
                        });
                        this.getJobDets();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
    },
};
</script>
